import { apiClient } from './apiClient';

// ============ Clinic ============
export interface ClinicPoints {
  pointsForRecommend: number;
  pointsPercentForPay: number;
  pointsForRegistration: number;
  pointsForReviewBranch: number;
  pointsForReviewDoctor: number;
  pointsPercentForPayTo?: number;
  pointsMaxPercentForPayment: number;
}

export interface Clinic {
  id: string;
  name: string;
  description?: string;
  appointmentLink?: string;
  points?: ClinicPoints;
}

export interface Branch {
  id: string;
  name: string;
  address?: string;
  phone?: string;
  workSchedule?: any;
  howToGetDescription?: string;
  mapImageName?: string;
  isActive: boolean;
}

export interface BranchContacts {
  name: string;
  phone: string;
  address: string;
  workSchedule?: any;
  isActive: boolean;
}

export interface ReviewLink {
  type: string;
  url: string;
}

export interface HowToGet {
  description?: string;
  mapImages: string[];
}

/**
 * Получить информацию о клинике
 */
export async function getClinicInfo(): Promise<{ clinic: Clinic }> {
  return apiClient.get('/webapp/clinic/info');
}

/**
 * Получить список филиалов
 */
export async function getBranches(): Promise<{ branches: Branch[] }> {
  return apiClient.get('/webapp/clinic/branches');
}

/**
 * Получить информацию о филиале
 */
export async function getBranch(branchId: string): Promise<{ branch: Branch }> {
  return apiClient.get(`/webapp/clinic/branches/${branchId}`);
}

/**
 * Получить контакты филиала
 */
export async function getBranchContacts(branchId: string): Promise<{ contacts: BranchContacts; reviewLinks: ReviewLink[] }> {
  return apiClient.get(`/webapp/clinic/branches/${branchId}/contacts`);
}

/**
 * Получить информацию "Как добраться"
 */
export async function getHowToGet(branchId: string): Promise<HowToGet> {
  return apiClient.get(`/webapp/clinic/branches/${branchId}/how-to-get`);
}

// ============ Posts (Акции и Новости) ============
export interface Post {
  id: string;
  content: string;
  type: 'promotions' | 'news';
  image?: string;
  buttons?: any[];
  createdAt: string;
}

const BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3001/api').replace(/\/api\/?$/, '');

export function getPostImageUrl(image: string | undefined): string | null {
  if (!image) return null;
  return `${BASE_URL}/static/${image}`;
}

export function getDoctorPhotoUrl(photo: string | undefined): string | null {
  if (!photo) return null;
  return `${BASE_URL}/static/${photo}`;
}

/**
 * Получить акции
 */
export async function getPromotions(): Promise<{ posts: Post[]; type: string }> {
  return apiClient.get('/webapp/posts/promotions');
}

/**
 * Получить новости
 */
export async function getNews(): Promise<{ posts: Post[]; type: string }> {
  return apiClient.get('/webapp/posts/news');
}

/**
 * Получить детали поста
 */
export async function getPost(postId: string): Promise<{ post: Post }> {
  return apiClient.get(`/webapp/posts/${postId}`);
}

